import { useState, MouseEvent } from 'react';
import { Link, useNavigate } from 'react-router';
import { FormattedMessage } from 'react-intl';

// material-ui
import { useTheme, Box, IconButton, List, ListItem, ListItemAvatar, ListItemText, Menu, MenuItem } from '@mui/material';

// trendio-selfcare-ui-kit
import { useGetMenuMaster } from '@trendiolive/trendio-selfcare-ui-kit';

// project import
import { useAppSelector } from 'app/hooks';
import useAuth from 'hooks/useAuth';
import MerchantAvatar from 'components/MerchantAvatar';

// assets
import RightOutlined from '@ant-design/icons/RightOutlined';

// ==============================|| DRAWER - USER ||============================== //

export default function NavUser() {
  const theme = useTheme();
  const navigate = useNavigate();

  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;
  const { merchant } = useAppSelector((store) => store.merchant);

  const { logout } = useAuth();
  const handleLogout = async () => {
    try {
      await logout();
      navigate(`/login`, {
        state: {
          from: ''
        }
      });
    } catch (err) {
      console.error(err);
    }
  };

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ p: 1.25, px: !drawerOpen ? 1.25 : 3, borderTop: '2px solid', borderTopColor: 'divider' }}>
      <List disablePadding>
        <ListItem
          disablePadding
          secondaryAction={
            <IconButton
              id="basic-button"
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
              aria-label="show more"
              sx={{
                transform: !open ? 'rotate(0deg)' : 'rotate(-90deg)',
                marginLeft: 'auto',
                color: theme.palette.secondary.dark,
                transition: theme.transitions.create('transform', {
                  duration: theme.transitions.duration.shortest
                }),
                ...(!drawerOpen && {
                  opacity: 0,
                  width: 50,
                  height: 50
                })
              }}
            >
              <RightOutlined style={{ fontSize: '0.625rem' }} />
            </IconButton>
          }
          sx={{ '& .MuiListItemSecondaryAction-root': { right: !drawerOpen ? -20 : -16 } }}
        >
          <ListItemAvatar>
            <MerchantAvatar {...{ merchant }} size={drawerOpen ? 46 : 0} />
          </ListItemAvatar>
          <ListItemText secondary={merchant?.name} />
        </ListItem>
      </List>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ 'aria-labelledby': 'basic-button' }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <MenuItem onClick={handleLogout}>
          <FormattedMessage id="log-out" />​
        </MenuItem>
        <MenuItem component={Link} to="/profiles/account/my-account" onClick={handleClose}>
          <FormattedMessage id="account" />​
        </MenuItem>
        <MenuItem component={Link} to="/support/help" onClick={handleClose}>
          <FormattedMessage id="support" />​
        </MenuItem>
      </Menu>
    </Box>
  );
}
